<template>
  <div class="wrapper" v-show="isShowMask">
    <transition name="content">
      <div class="content_view" v-show="isShow">
        <div class="title_view">
          <div class="title">请选择类型</div>
          <div class="close_view" @click="hidden">
            <!-- <icon class="close_icon" :type="'clear'" size="26" /> -->
          </div>
        </div>
        <div class="select_top">
          <div
            class="select_top_item"
            ref="select_top_item"
            v-for="(item, index) in dataList"
            :key="index"
            @click="select_top_item_click(index)"
          >
            <span class="address_value">{{ item }}</span>
          </div>
          <div class="indicator" :style="{ left: indicatorStyleLeft + 'px' }" ref="indicator"></div>
        </div>
        <div class="swiper">
          <div v-for="(swiper_item, swiper_index) in dataList" :key="swiper_index" style="width: 100%; height: 100%">
            <div class="swiper-item">
              <div class="scroll-view-item">
                <div>
                  <div v-if="currentIndex == 0" style="height: 100%">
                    <div
                      class="address_item"
                      v-for="(item, index) in list0"
                      :key="index"
                      @click="address_item_click(swiper_index, index)"
                    >
                      <img
                        v-if="selectIndexArr[swiper_index] === index"
                        class="address_item_icon"
                        src="@images/gou.png"
                      />
                      {{ item.title }}
                    </div>
                  </div>
                  <div v-if="currentIndex == 1" style="height: 100%">
                    <div
                      class="address_item"
                      v-for="(item, index) in list1"
                      :key="index"
                      @click="clickEj(swiper_index, index)"
                    >
                      <img
                        v-if="selectIndexArr[swiper_index] === index"
                        class="address_item_icon"
                        src="@images/gou.png"
                      />
                      {{ item.title }}
                    </div>
                  </div>
                  <div v-if="currentIndex == 2" style="height: 100%">
                    <div
                      class="address_item"
                      v-for="(item, index) in list2"
                      :key="index"
                      @click="clickSj(swiper_index, index)"
                    >
                      <img
                        v-if="selectIndexArr[swiper_index] === index"
                        class="address_item_icon"
                        src="@images/gou.png"
                      />
                      {{ item.title }}
                    </div>
                  </div>
                  <div v-if="currentIndex == 3" style="height: 100%">
                    <div
                      class="address_item"
                      v-for="(item, index) in list3"
                      :key="index"
                      @click="clickSsj(swiper_index, index)"
                    >
                      <img
                        v-if="selectIndexArr[swiper_index] === index"
                        class="address_item_icon"
                        src="@images/gou.png"
                      />
                      {{ item.title }}
                    </div>
                  </div>
                  <div v-if="currentIndex == 4" style="height: 100%">
                    <div
                      class="address_item"
                      v-for="(item, index) in list4"
                      :key="index"
                      @click="clickWj(swiper_index, index)"
                    >
                      <img
                        v-if="selectIndexArr[swiper_index] === index"
                        class="address_item_icon"
                        src="@images/gou.png"
                      />
                      {{ item.title }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="mask" @click="hidden" v-show="isShowMask"></div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
export default {
  name: 'select-sort',
  props: {
    type: {
      type: Number,
      default: 0,
    },
    url: {
      type: String,
      default: '',
    },
    isMdjf: {
      type: Boolean,
      default: false,
    },
    pCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isShow: false,
      isShowMask: false,
      dataList: ['请选择'],
      currentIndex: 0,
      cityData: {},
      cityAreaArray: [],
      selectIndexArr: [],
      indicatorStyleLeft: 16,
      list0: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      yjValue: '',
      ejValue: '',
      sjValue: '',
      ssjValue: '',
      wjValue: '',
      value: [],
      sjType: this.type,
      code: this.pCode,
    }
  },
  methods: {
    initPoition() {
      this.dataList = ['请选择']
      this.currentIndex = 0
      this.changeIndicator(0)
    },
    show() {
      this.isShow = true
      this.isShowMask = true
      this.value = []
      this.initPoition()
    },
    hidden() {
      this.isShow = false
      setTimeout(() => {
        this.isShowMask = false
      }, 500)
    },
    select_top_item_click(index) {
      this.currentIndex = index
      this.$nextTick(() => {
        this.changeIndicator(index)
      })
    },
    swiperChange(event) {
      let index = event.detail.current
      this.currentIndex = index

      this.changeIndicator(index)
    },
    changeIndicator(index) {
      let indicatorWidth = 30
      let itemWidth = 42
      let itemCenterX = 10 + index * 80 + itemWidth / 2
      let left = itemCenterX - indicatorWidth / 2

      this.indicatorStyleLeft = left
      // 	}
    },
    address_item_click(swiper_index, index) {
      // console.log(swiper_index,index)
      // this.selectIndexArr.splice(swiper_index, 5,index)

      //判断当前是否为最下一级
      let currentObj = this.list0[index]
      this.list1 = currentObj.children
      console.log(this.list1)
      this.goNextPage(currentObj, swiper_index)
    },

    clickEj(swiper_index, index) {
      let currentObj = this.list1[index]
      this.list2 = currentObj.children
      this.goNextPage(currentObj, swiper_index)
    },
    clickSj(swiper_index, index) {
      let currentObj = this.list2[index]
      this.list3 = currentObj.children
      this.goNextPage(currentObj, swiper_index)
    },
    clickSsj(swiper_index, index) {
      let currentObj = this.list3[index]
      this.list4 = currentObj.children
      this.goNextPage(currentObj, swiper_index)
    },
    clickWj(swiper_index, index) {
      let currentObj = this.list4[index]
      this.list5 = currentObj.children

      this.goNextPage(currentObj, swiper_index)
    },
    goNextPage(currentObj, swiper_index) {
      if (this.value.length > this.currentIndex) {
        this.value[swiper_index] = currentObj.title
        // this.value.splice(swiper_index,this.value.length);
      } else {
        this.value.push(currentObj.title)
      }
      if (currentObj.children && currentObj.children.length > 0) {
        this.dataList.splice(swiper_index, 5, currentObj.title)
        this.dataList.splice(swiper_index + 1, 0, '请选择')
        this.currentIndex = swiper_index + 1
        this.$nextTick(() => {
          this.changeIndicator(this.currentIndex)
        })
      } else {
        let text = this.value.join('>')
        var data = { text: text, value: currentObj.code }
        this.$emit('selectType', data)
        setTimeout(() => {
          this.isShow = false
        }, 100)
        setTimeout(() => {
          this.isShowMask = false
        }, 500)
      }
    },
  },
  created() {
    getAction(this.url).then((res) => {
      let list = res.result
      let arr = list.filter((obj, index) => {
        return this.code == obj.code
      })
      if (arr[0].children && arr[0].children.length > 0) {
        this.list0 = arr[0].children
      } else {
        this.list0 = arr
      }
      console.log(this.list0)
    })
  },
}
</script>

<style lang="less" scoped >
.wrapper {
  position: fixed;
  z-index: 1999;
  top: -44px;
  left: 0;
  bottom: 0;
  right: 0;
  .content_view {
    z-index: 999;
    background: white;
    position: absolute;
    height: 50%;
    left: 0;
    bottom: 0;
    right: 0;
    // border-top-left-radius: 20px;
    // border-top-right-radius: 20px;
    .title_view {
      height: 12%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 8px;
      .title {
        font-size: 14px;
      }
      .close_view {
        height: 30px;
        width: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .select_top {
      height: 8%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 10px;
      position: relative;
      box-sizing: border-box;
      .select_top_item {
        width: 80px;
        font-size: 14px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .indicator {
        position: absolute;
        width: 30px;
        height: 2px;
        background: #f00;
        left: 16px;
        bottom: 0;
        transition: left 0.5s ease;
      }
    }
    .swiper {
      height: 80%;
      position: relative;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      .swiper-item {
        height: 100%;
        .scroll-view-item {
          height: 100%;
          padding: 0 10px;
          overflow-y: scroll;
          .address_item {
            padding: 5px 0;
            font-size: 14px;
            display: flex;
            align-items: center;
            .address_item_icon {
              width: 20px;
              height: 20px;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #000;
  opacity: 0.6;
}

.content-enter {
  transform: translateY(100%);
}
.content-enter-to {
  transform: translateY(0%);
}
.content-enter-active {
  transition: transform 0.5s;
}
.content-leave {
  transform: translateY(0%);
}
.content-leave-to {
  transform: translateY(100%);
}
.content-leave-active {
  transition: transform 0.5s;
}
</style>
